<script>
  import { onMount } from 'svelte'

  import { animate } from 'animejs'

  import LinkButton from '~/components/ui/link-button.svelte'

  onMount(() => {
    animate('.animation .el-animated', {
      rotateX: [90, 0],
      duration: 1 * 1000,
    })
  })
</script>

<style>
  .article {
    display: flex;
    align-items: center;
  }
</style>

<section
  class="animation section layer-0 relative mb-[122px] min-h-[50vh] w-full pt-[122px] lg:my-0 lg:mb-[64px] lg:h-[72dvh] lg:py-0"
>
  <div>
    <article
      class="article | row-container row-center | layer-2 relative z-20 flex-col items-center gap-8 text-black lg:h-[80vh] lg:flex-row lg:px-0"
    >
      <div class="order-1 grow space-y-8 text-center lg:order-1 lg:w-1/2 lg:text-left">
        <h1 class="el-animated w-full text-4xl font-semibold leading-normal lg:w-10/12 lg:text-5xl">
          Software sob Medida para sua Empresa
        </h1>

        <p class="el-animated text-md mx-auto leading-normal md:w-10/12 lg:mx-0 lg:text-lg">
          "Já deu, não queremos mais soluções prontas, Queremos algo único e sob-medida.", Veio ao
          lugar certo, a gente tá aí para melhorar o dia a dia, Na criação de soluções sob-medida,
          Chega de pagar pelo que você não usa!.
        </p>
        <div class="el-animated | row | justify-center lg:justify-start">
          <LinkButton
            colorPalette="secondary"
            variant="solid"
            class=" md:text-md block w-6/12 rounded-full text-sm lg:w-auto lg:rounded-l-none lg:rounded-r-full"
            href="/contato"
          >
            Solicitar orçamento de escopo fechado
          </LinkButton>
        </div>

        <ul class="flex justify-center gap-8 text-center lg:justify-start">
          <li class="flex flex-col gap-2">
            <span class="text-2xl font-bold text-brand"> 24/7 </span>
            <span class="text-sm"> Suporte disponível </span>
          </li>

          <!-- <li class="flex flex-col gap-2">
						<span class="text-2xl font-bold text-brand"> +3 Anos </span>
						<span class="text-sm"> Experiência </span>
					</li> -->

          <li class="flex flex-col gap-2">
            <span class="text-2xl font-bold text-brand"> +25% </span>
            <span class="text-sm"> Impulsionamento </span>
          </li>
        </ul>
      </div>

      <div class="order-2 grow lg:order-2 lg:w-1/2">
        <figure class="relative">
          <picture>
            <img
              class="h-full w-full rounded-lg object-cover"
              decoding="async"
              fetchpriority="high"
              loading="eager"
              src="/webp/hero.webp"
              width="1400"
              height="900"
              alt="A imagem contém uma mesa com pessoas fazendo aperto de mão cruzado, levando em consideração a colaboração da equipe e planejamento da lutruvials."
            />
          </picture>

          <div
            class="animate-float | absolute -left-[96px] top-[72px] hidden -translate-x-1/2 rounded-full border border-white/40 bg-brand/60 px-4 py-2 text-sm text-white backdrop-blur-sm lg:flex"
          >
            <p>24/7 Suporte Disponível</p>
            <!-- <p>+3 anos de experiência</p> -->
          </div>

          <div
            class="animate-float | absolute bottom-[72px] left-[calc(100%-48px)] hidden min-h-[96px] w-auto min-w-[96px] -translate-x-1/2 items-center rounded-lg border border-white/40 bg-brand/60 px-4 py-2 text-sm text-white backdrop-blur-sm lg:flex"
          >
            <p class="text-center">
              <span class="text-lg font-bold text-secondary-500">+25%</span>
              <span>Velocidade</span>
            </p>
          </div>
        </figure>
      </div>
    </article>
  </div>
</section>
